import React from 'react';
export const Minus = props => (
  <svg viewBox="0 0 20 20" width="16px" height="16px" {...props} className={`w-icon ${props.className ? props.className : ''}`}><path d="M0.7,10.4 C0.313400675,10.4 0,10.0865993 0,9.7 C0,9.31340068 0.313400675,9 0.7,9 L19.3055622,9 C19.6921615,9 20.0055622,9.31340068 20.0055622,9.7 C20.0055622,10.0865993 19.6921615,10.4 19.3055622,10.4 L0.7,10.4 Z" fillRule="evenodd" /></svg>
);
